<template>
  <v-app-bar
      app
      color="#fff"
      dense
      :height="$vuetify.breakpoint.smAndDown ? 48 : 75"
  >
        <v-app-bar-nav-icon
            class="d-md-none"
            @click.stop="setDrawer(!drawer)"
        ></v-app-bar-nav-icon>

        <v-img
            class="d-none d-md-flex"
            contain
            src="/img/logo.svg"
            position="left center"
            max-width="200"
            max-height="38"
            @click="goto('Home')"
        />
<!--        <v-app-bar-title>{{ $route.meta.title }}</v-app-bar-title>-->

        <v-spacer/>
        <v-btn
            text
            depressed
            x-large
            v-for="item in availableMenuItems" :key="item.title"
            class="d-none d-md-flex btn-header-menu"
            @click="goto(item)"
        >
            {{ item.title }}
        </v-btn>

        <v-spacer/>

        <template v-if="isEnableAdminMenu">
            <v-menu
                v-if="currentUser"
                min-width="150"
                left
                offset-y
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        depressed
                        outlined
                        color="var(--primary-color, #023894)"
                        class="btn-after-login"
                    >
                        <v-icon small>
                            mdi-account-circle
                        </v-icon>
                        {{ currentUser ? currentUser.userName : null }}
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item href="/backoffice">
                        <v-list-item-content>
                            <v-list-item-title>백오피스</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item href="/backoffice/profile">
                        <v-list-item-content>
                            <v-list-item-title>프로필</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                    <v-list-item @click="logout">
                        <v-list-item-content>
                            <v-list-item-title>로그아웃</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn
                v-else
                depressed
                dark
                color="var(--secondary-color, #023894)"
                href="/backoffice/login"
                class="btn-before-login"
            >
                로그인
                <v-icon small>
                    mdi-login
                </v-icon>
            </v-btn>
        </template>
    </v-app-bar>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
    name: 'HomeAppBar',
    data: () => ({
        group: null,
        right: null,
    }),

    computed: {
        ...mapState(['drawer', 'menuItemList', 'currentUser']),

        availableMenuItems() {
            return this.menuItemList
                .filter(item => {
                    return item.isShow;
                })
                .filter(item => !item.requiredAuth || (item.requiredAuth && this.currentUser));
        },

        isEnableAdminMenu() {
            return this.$code.get('service.config.enable_admin_menu') === 'Y';
        }
    },

    methods: {
        ...mapMutations({
            setDrawer: 'SET_DRAWER',
        }),

        goto(menuItem) {
            if (menuItem.href) {
                window.location.href = menuItem.href;
            } else if (this.$route.name !== menuItem.name) {
                this.$router.push({ name: menuItem.name });
            }
        },

        logout() {
            this.$store.dispatch('logout');
        }
    }
}
</script>

<style scoped>
.v-menu__content,
.v-menu__content .v-list {
    padding: 0;
    border: 1px solid #eee !important;
    border-radius: 12px 12px !important;
    box-shadow: 1px 2px 5px rgb(138, 138, 138, 0.16) !important;
}
.v-list-item {
    min-height: 0;
}
.v-list-item .v-list-item__title {
    text-align: center;
    color: #424242;
}
</style>